export default __webpack_public_path__ + "static/media/d-and-d-initiative-tracker.332d61c0.png";